import React from 'react';
import loadable from '@loadable/component';

import { withError } from '../../../shared/components/error-boundary';
const GraphQLClient = loadable(() => import('./graphql-client'));

export default withError(({ slugInfo }) => {
    return <GraphQLClient slugInfo={slugInfo} />;
});
